import request from "utils/request";

export async function getLesson(page) {
  return request.get(`/lesson/lesson.php?page=${page}`, "nocache");
}

export async function getLessonv2(page) {
  return request.get(`/lesson/lessonv2.php?page=${page}`, "nocache");
}

export async function getMyLesson(page) {
  return request.get(`/lesson/myLesson.php?page=${page}`, "nocache");
}

export async function getMyLessonv2(page) {
  return request.get(`/lesson/myLessonv2.php?page=${page}`, "nocache");
}

export async function getMyQualification(data, customConfig = {}) {
  return request.post(
    "/lesson/startLessonv2.php",
    data,
    Object.assign({ cache: "nocache" }, customConfig)
  );
}

export async function getChatHistory(id) {
  return request.get(`/history/playbackv2.php?lesson_id=${id}`, "nocache");
}

export async function getPreLesson(data) {
  return request.post("/lesson/preLesson.php", data, "nocache");
}

export function getDemoAnswer() {
  return request.get(`/lesson/demoAnswer.php`, "nocache");
}

export async function postSubmitAnswer(data) {
  return request.post("/lesson/submitAnswer.php", data, "nocache");
}

export function getDemoMeaterial() {
  return request.get(`/materials/demoMeaterial.php`, "nocache");
}

export async function postSubmitAnswerV2(data) {
  return request.post("/lesson/submitAnswerV2.php", data, "nocache");
}

export function getAppToken() {
  return request.get(`/upload/getAppTokenv3.php`, "nocache");
}

// 获取课堂聊天记录
export function getLessonChatHistory(lessonId, token) {
  const tokenParam = token ? `&token=${encodeURIComponent(token)}` : "";
  return request.get(`/history/playbackv3.php?lesson_id=${lessonId}${tokenParam}`);
}

// 获取课堂得分
export function getLessonScore(lessonId, token) {
  const tokenParam = token ? `&token=${encodeURIComponent(token)}` : "";
  return request.get(`/history/lessonScore.php?lesson_id=${lessonId}${tokenParam}`);
}

// 获取课堂用时
export function getLessonTime(lessonId, token) {
  const tokenParam = token ? `&token=${encodeURIComponent(token)}` : "";
  return request.get(`/history/lessonTime.php?lesson_id=${lessonId}${tokenParam}`);
}

//翻译
// export async function translateV2(data) {
//   return request.post("/assistant/translateV2.php", data, "nocache");
// }

export async function translateV2(data) {
  return request.post("/assistant/translateV2.php", data, {
    responseType: "text",
    cache: "nocache",
  });
}

//单词
export async function getPhonetic(data) {
  return request.post("/ecdictv2/phonetic.php", data, "nocache");
}

export async function unwordCollections(data) {
  return request.post("/ecdictv2/unwordCollections.php", data, "nocache");
}

export async function wordCollections(data) {
  return request.post("/ecdictv2/wordCollections.php", data, "nocache");
}
